import {useArabicRulesInCombineNode} from "@/components/widgets/list_download/common.js";

function washFn(walkedNode, item){
  if(walkedNode.modeData && walkedNode.modeData[item.flag]){
    walkedNode.modeData[item.flag] = useArabicRulesInCombineNode({
      componentName: item.componentName,
      data: walkedNode.modeData[item.flag]
    }).data
  }
}

export function washData(walkedNode){
  if(
    walkedNode._type === 'list_case_style1' ||
    walkedNode._type === 'list_case_style2' ||
    walkedNode._type === 'list_case_style3'
  ){
    [{
      flag: 'caseList_listItem_right_title',
      componentName: 'text_title',
    },{
      flag: 'caseList_listItem_right_paragraph',
      componentName: 'text_paragraph',
    },{
      flag: 'caseList_listItem_right_btn',
      componentName: 'button_text',
    }].forEach((item)=>{
      washFn(walkedNode, item)
    })
  }else if(walkedNode._type === 'list_case_style4'){
    [{
      flag: 'caseList_listItem_right_title',
      componentName: 'text_title',
    }].forEach((item)=>{
      washFn(walkedNode, item)
    })
  }else if(
    walkedNode._type === 'list_case_style5' ||
    walkedNode._type === 'list_case_style6' ||
    walkedNode._type === 'list_case_style7'
  ){
    [{
      flag: 'caseList_listItem_right_title',
      componentName: 'text_title',
    },{
      flag: 'caseList_listItem_right_paragraph',
      componentName: 'text_paragraph',
    }].forEach((item)=>{
      washFn(walkedNode, item)
    })
  }

}
